import { Box, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material"
import { ArrayField, Datagrid, NumberField, RecordContextProvider, TextField, WithRecord, useRecordContext, useTranslate } from "react-admin"
import { InvoiceReadModel } from "../../../GeneratedClients/FreeBillApi"

const InvoiceItemsComponent = () => {
  const translate = useTranslate()
  const record = useRecordContext<InvoiceReadModel>()
  if(!record) return null

  return (
    <Box mt={3}>
      <ArrayField source="invoiceItems">
        <Datagrid hover={false} className="invoiceItems" bulkActionButtons={false} rowSx={() => ({verticalAlign: "top"})} >
          <TextField source="itemName" label="resources.products.productName" sortable={false} />
          <TextField whiteSpace={"pre-line"} source="description" label="resources.items.description" sortable={false} />
          <NumberField source="quantity" label="resources.items.quantity" sortable={false} />
          <NumberField source="price" label="resources.common.price" options={{ style: 'currency', currency: 'EUR' }} sortable={false} />
          <NumberField source="tax_in_percent" label="resources.common.tax_in_percent" options={{ style: 'percent'}} sortable={false} />
          {
            record.containsItemWithDiscount &&
            <NumberField source="discount_in_percent" label="resources.common.discount_in_percent" options={{ style: 'percent'}} sortable={false} />
          }
          <NumberField source="totalNetAmount" label="resources.invoices.netAmount" options={{ style: 'currency', currency: 'EUR' }} sortable={false} />
        </Datagrid>
      </ArrayField>
      <Box display={'flex'} justifyContent={'flex-end'}>
        <Table size="small" sx={{width: '44.5%'}}>
          <TableBody>
            <TableRow>
              <TableCell><Typography variant="body2">{translate("resources.invoices.netAmount")}</Typography></TableCell>
              <TableCell align="right"><NumberField source="netAmount" options={{ style: 'currency', currency: 'EUR' }}/></TableCell>
            </TableRow>
            <WithRecord render={(record: InvoiceReadModel) => (
              record.taxAmounts?.map((taxAmount, index) => {
                if(taxAmount.amount && taxAmount.amount !== 0)
                return (
                  <RecordContextProvider key={index + 1} value={taxAmount}>
                    <TableRow>
                      <TableCell><Typography variant="body2">{translate("resources.invoices.taxAmount")} {taxAmount.name}</Typography></TableCell>
                      <TableCell align="right">
                          <NumberField source="amount" options={{ style: 'currency', currency: 'EUR' }}/>
                      </TableCell>
                    </TableRow>
                  </RecordContextProvider>
                )
              })
            )}/>
            <TableRow>
              <TableCell><Typography variant="body2">{translate("resources.invoices.grossAmount")}</Typography></TableCell>
              <TableCell align="right"><NumberField source="grossAmount" options={{ style: 'currency', currency: 'EUR' }}/></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Box>
  )
}

export default InvoiceItemsComponent